import { LuChevronDown, LuChevronUp ,LuCheck, LuChevronRight, LuChevronLeft, LuCircle, LuSearch  } from 'react-icons/lu';
import { RxHamburgerMenu, RxCross1 } from 'react-icons/rx';
import { RiCircleFill } from 'react-icons/ri';
import { ImCross} from 'react-icons/im';
import { IoIosArrowForward } from 'react-icons/io';
import { IoIosArrowBack } from "react-icons/io";
import { IoReload, IoPerson } from "react-icons/io5";

export const ChevronDownIcon = LuChevronDown;
export const ChevronUpIcon = LuChevronUp;
export const CheckIcon = LuCheck;
export const ChevronRightIcon = LuChevronRight;
export const ChevronLeftIcon = LuChevronLeft;
export const CircleIcon = LuCircle;
export const DotIcon = RiCircleFill;
export const SearchIcon = LuSearch;
export const HamburgerMenuIcon = RxHamburgerMenu;
export const CrossIcon = RxCross1;
export const CrossBoldIcon = ImCross;
export const ArrowIconRight = IoIosArrowForward;
export const ArrowIconLeft = IoIosArrowBack;
export const ReloadIcon = IoReload;
export const PersonIcon = IoPerson;
